import type { ReactNode } from 'react';
import { Link } from '@chakra-ui/react';
import Cookies from 'js-cookie';
import { useScript } from 'usehooks-ts';

type ReCaptchaAction =
    | 'accountRegister'
    | 'checkoutGoToReview'
    | 'checkoutApplyGC'
    | 'checkoutLogin'
    | 'giftCard';

type GetReCaptchaTokenResponse = Promise<string | null>;

const COOKIE_NAME_KIOSK_LOCATION_ID = 'kiosk_location_id';

export const recaptchaMessageParts = (parts: ReactNode[]): ReactNode => (
    <Link
        data-testid="recaptcha-error-text"
        variant="tertiary"
        colorScheme="text-link"
        href="tel:+13175592041"
        textDecoration="underline"
    >
        {parts}
    </Link>
);

const getReCaptchaToken = async (
    siteKey: string,
    action: ReCaptchaAction,
): GetReCaptchaTokenResponse => {
    let token: string | null = '';
    if (typeof window !== 'undefined' && window.grecaptcha) {
        token = await window.grecaptcha.execute(siteKey, { action });
    }
    return token;
};

export const LoadReCaptchaScript: ({
    siteKey,
    enabled,
    action,
}: {
    siteKey: string | null | undefined;
    enabled: boolean;
    action: ReCaptchaAction;
}) => () => GetReCaptchaTokenResponse = ({ siteKey, enabled, action }) => {
    useScript(`https://www.google.com/recaptcha/api.js?render=${siteKey}`, {
        removeOnUnmount: false,
        shouldPreventLoad: !enabled || !siteKey,
    });
    if (!siteKey || !enabled) {
        return () => Promise.resolve(null);
    }
    return () => getReCaptchaToken(siteKey, action);
};

export const getKioskLocationId = (): string | null => {
    let kioskLocationId: string | null | undefined = Cookies.get(COOKIE_NAME_KIOSK_LOCATION_ID);
    if (!kioskLocationId) {
        kioskLocationId = window.localStorage.getItem('kiosk_location_id');
    }
    return kioskLocationId || null;
};
